import React, { useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./Navbar3.css";

import firebaseApp from "../../../firebase/Credentials.js";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { getFirestore, doc, getDoc } from "firebase/firestore";

const auth = getAuth(firebaseApp);
const firestore = getFirestore(firebaseApp);

export default function NavBar3() {
  const [user, setUser] = useState(null);

  async function getRol(uid) {
    const docuRef = doc(firestore, `usuarios/${uid}`);
    const docuSnap = await getDoc(docuRef);
    return docuSnap.data()?.rol;
  }

  function setUserWithFirebaseAndRol(usuarioFirebase) {
    getRol(usuarioFirebase.uid).then((rol) => {
      setUser({
        uid: usuarioFirebase.uid,
        email: usuarioFirebase.email,
        rol,
      });
    });
  }

  onAuthStateChanged(auth, (usuarioFirebase) => {
    if (usuarioFirebase && !user) setUserWithFirebaseAndRol(usuarioFirebase);
    if (!usuarioFirebase) setUser(null);
  });

  return (
    <Navbar className="nav-grande2 sticky-top" expand="lg">
      <Container fluid style={{ paddingLeft: "100px", paddingRight: "100px" }}>
        {/* LOGO */}
        <Navbar.Brand as={Link} to="/" className="brand-fix">
          <img
            className="logotipoo"
            src={process.env.REACT_APP_NAVBAR}
            alt="Logo Ciclopista"
          />
        </Navbar.Brand>

        <Navbar.Toggle aria-controls="navbarScroll" />

        <Navbar.Collapse id="navbarScroll">
          <Nav className="ms-auto my-2 my-lg-0" navbarScroll>
            <Nav.Link as={Link} to="/" className="Menu">
              Inicio
            </Nav.Link>

            <Nav.Link as={Link} to="/orders" className="Menu">
              Ordenes
            </Nav.Link>

            <Nav.Link as={Link} to="/orders/pendiente" className="Menu">
              Pendientes
            </Nav.Link>

            <Nav.Link as={Link} to="/orders/en_proceso" className="Menu">
              En proceso
            </Nav.Link>

            <Nav.Link as={Link} to="/orders/finalizada" className="Menu">
              Finalizadas
            </Nav.Link>

            {user && (
              <Nav.Link onClick={() => signOut(auth)} className="CerrarLink">
                Cerrar Sesión
              </Nav.Link>
            )}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
